import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import InstitutionHeader from 'Components/ComponentLibrary/Molecules/InstitutionHeader/InstitutionHeader';
import AggregatorRowDetails
  from 'Views/Page/Content/Templates/InstitutionSuccessRatesTemplate/MainPanel/SuccessRateDetails/aggregatorRowDetails';

const styles = (theme) => ({
  root: {
    width: '100%',
  },
  header: {
    paddingBottom: theme.spacing(2),
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: theme.spacing(3),
  },
});

const SuccessRateDetailsLayout = ({
  className,
  classes,
}) => {
  const { resource } = useMetaLayoutContext();

  const name = resource.attr('name');
  const logo = resource.attr('logo');

  const activeAggregator = resource.attr('activeAggregator');

  const finicityTitle = 'Finicity';
  const yodleeTitle = 'Yodlee';
  const plaidTitle = 'Plaid';
  const hasFinicity = resource.attr('finicityFailedLinks') !== '';
  const hasYodlee = resource.attr('yodleeFailedLinks') !== '';
  const hasPlaid = resource.attr('plaidFailedLinks') !== '';

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <InstitutionHeader className={classes.header} logo={logo} name={name} />

      <MetaControlField attr={'institutionId'} />
      <MetaControlField attr={'baseUrl'} />

      <Box className={classes.container}>
        {hasFinicity && <AggregatorRowDetails
          title={finicityTitle}
          successLinks={resource.attr('finicitySuccessfulLinks')}
          failedLinks={resource.attr('finicityFailedLinks')}
          successRate={resource.attr('finicitySuccessRate')}
          isActive={activeAggregator === finicityTitle}
        />}

        {hasYodlee && <AggregatorRowDetails
          title={yodleeTitle}
          successLinks={resource.attr('yodleeSuccessfulLinks')}
          failedLinks={resource.attr('yodleeFailedLinks')}
          successRate={resource.attr('yodleeSuccessRate')}
          isActive={activeAggregator === yodleeTitle}
        />}

        {hasPlaid && <AggregatorRowDetails
          title={plaidTitle}
          successLinks={resource.attr('plaidSuccessfulLinks')}
          failedLinks={resource.attr('plaidFailedLinks')}
          successRate={resource.attr('plaidSuccessRate')}
          isActive={activeAggregator === plaidTitle}
        />}
      </Box>
    </Box>
  );
};

SuccessRateDetailsLayout.defaultProps = {
  className: '',
};

SuccessRateDetailsLayout.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SuccessRateDetailsLayout);
